module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4jzOF"))).then(() => parcelRequire('3ZPLq'));